import {ReactComponent as CreditCardIcon} from './creditCard.svg'

function CreditCard() {
  return <CreditCardIcon />
}

export default CreditCard
